import { useEffect } from "react"

import { EthereumProviderKeyEnum } from "types/connection"

import { LocalStorageKey, useLocalStorage } from "../use-localstorage"
import { useWeb3Simple } from "./use-base"
import { useWallet } from "./use-wallet"

export function useRestoreConnection() {
  const [lastConnection] = useLocalStorage(LocalStorageKey.LAST_CONNECTION)
  const { connectionType } = useWallet()
  const { connected, connect, library, connectWalletConnect } = useWeb3Simple()

  useEffect(() => {
    if (library && connectionType === "external" && !connected) {
      if (lastConnection) {
        if (lastConnection === EthereumProviderKeyEnum.WALLET_CONNECT) {
          connectWalletConnect()
        } else {
          connect()
        }
      }
    }
  }, [library, connectionType])
}
